module.exports = __webpack_public_path__ + "img/1559570760.369e5317.jpg";